import React from 'react';
import './GetQuote.css';
import { useNavigate } from 'react-router-dom'; // Add for navigation
const GetQuote = () => {
  const navigate = useNavigate(); // Hook to navigate if token expires
  const Buttonclick=(e)=>{
    navigate("/subcontractform")
  }
  return (
    <section className="get-quote">
      <div className="get-quote-content">
        <img
          src="/truck1.jpg" // Replace with your image URL
          alt="Get a Quote"
          className="get-quote-image"
        />
        <div className="get-quote-text">
          <h2 className="get-quote-heading">Get a Quote for Car Movement</h2>
          <p className="get-quote-paragraph">
            Ready to transport your vehicle? Click the button below to get a personalized quote for your vehicle's movement. 
            We offer competitive pricing and reliable service to ensure your vehicle reaches its destination safely.
          </p>
          <button onClick={Buttonclick} className="get-quote-button" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '0 auto' }}>
  Get A Quote Now
</button>

        </div>
      </div>
    </section>
  );
};

export default GetQuote;
